<template>
  <div class="container-fluid mt-5 p-4 p-lg-8">
    <div class="d-flex justify-content-between">
      <div>
        <ul>
          <li>
            <router-link
              to="/products"
              class="link-light mb-3 text-decoration-none"
              >Products</router-link
            >
          </li>
          <li>
            <router-link
              to="/roadmap"
              class="link-light mb-3 text-decoration-none"
              >Roadmap</router-link
            >
          </li>
          <li>
            <a
              href="https://opensea.io/"
              target="_blank"
              class="link-light mb-3 text-decoration-none"
              >OPEN SEA</a
            >
          </li>
        </ul>
        <ul class="d-flex mt-5">
          <li class="me-4">
            <a href="#" target="_blank" class="svg-gray">
              <!-- <img src="../assets/images/icon/Discord.svg" alt="Discord" /> -->
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.7032 6.76915C23.9186 5.95029 22.0048 5.34699 20.0039 5.00145C19.9674 4.99478 19.931 5.01145 19.9123 5.04478C19.6661 5.48253 19.3935 6.05361 19.2026 6.50248C17.0505 6.18028 14.9094 6.18028 12.8014 6.50248C12.6104 6.04363 12.3279 5.48253 12.0807 5.04478C12.0619 5.01256 12.0255 4.99589 11.9891 5.00145C9.98923 5.34588 8.07549 5.94918 6.28976 6.76915C6.2743 6.77581 6.26105 6.78693 6.25225 6.80137C2.62229 12.2245 1.62789 17.5142 2.11571 22.7385C2.11792 22.764 2.13226 22.7885 2.15213 22.804C4.54708 24.5628 6.86699 25.6305 9.14383 26.3383C9.18027 26.3494 9.21887 26.3361 9.24206 26.3061C9.78065 25.5706 10.2607 24.795 10.6724 23.9795C10.6967 23.9317 10.6735 23.8751 10.6238 23.8562C9.86232 23.5673 9.1372 23.2151 8.43968 22.8151C8.38451 22.7829 8.3801 22.704 8.43085 22.6662C8.57763 22.5562 8.72446 22.4418 8.86461 22.3262C8.88997 22.3051 8.92531 22.3007 8.95512 22.314C13.5375 24.4062 18.4985 24.4062 23.0268 22.314C23.0566 22.2996 23.0919 22.304 23.1184 22.3251C23.2586 22.4407 23.4054 22.5562 23.5533 22.6662C23.604 22.704 23.6007 22.7829 23.5455 22.8151C22.848 23.2229 22.1229 23.5673 21.3603 23.8551C21.3106 23.874 21.2885 23.9317 21.3128 23.9795C21.7333 24.7939 22.2134 25.5694 22.742 26.3049C22.7641 26.3361 22.8038 26.3494 22.8403 26.3383C25.1282 25.6305 27.4481 24.5628 29.843 22.804C29.864 22.7885 29.8772 22.7651 29.8794 22.7396C30.4633 16.6998 28.9016 11.4534 25.7396 6.80247C25.7319 6.78693 25.7186 6.77581 25.7032 6.76915ZM11.3567 19.5575C9.97708 19.5575 8.84032 18.2909 8.84032 16.7354C8.84032 15.1799 9.95504 13.9133 11.3567 13.9133C12.7694 13.9133 13.8951 15.191 13.873 16.7354C13.873 18.2909 12.7583 19.5575 11.3567 19.5575ZM20.6605 19.5575C19.281 19.5575 18.1442 18.2909 18.1442 16.7354C18.1442 15.1799 19.2589 13.9133 20.6605 13.9133C22.0732 13.9133 23.199 15.191 23.1769 16.7354C23.1769 18.2909 22.0732 19.5575 20.6605 19.5575Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li class="me-4">
            <a href="#" target="_blank" class="svg-gray">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.0499 16.3036C18.0499 21.3312 14.0093 25.4068 9.02511 25.4068C4.04097 25.4068 0 21.3303 0 16.3036C0 11.2768 4.04067 7.19995 9.02511 7.19995C14.0096 7.19995 18.0499 11.2759 18.0499 16.3036Z"
                  fill="white"
                />
                <path
                  d="M27.9504 16.3035C27.9504 21.0359 25.9301 24.8738 23.4379 24.8738C20.9456 24.8738 18.9253 21.0359 18.9253 16.3035C18.9253 11.5711 20.9453 7.73315 23.4375 7.73315C25.9298 7.73315 27.9501 11.5698 27.9501 16.3035"
                  fill="white"
                />
                <path
                  d="M32 16.3036C32 20.5427 31.2896 23.9813 30.4129 23.9813C29.5363 23.9813 28.8262 20.5437 28.8262 16.3036C28.8262 12.0636 29.5366 8.62598 30.4129 8.62598C31.2893 8.62598 32 12.0633 32 16.3036Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li class="me-4">
            <a href="#" target="_blank" class="svg-gray">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.3282 9.45174C26.3387 9.69258 26.3387 9.92247 26.3387 10.1633C26.3493 17.4652 20.9846 25.8947 11.1738 25.8947C8.28026 25.8947 5.43948 25.0299 3 23.4097C3.42242 23.4644 3.84484 23.4863 4.26726 23.4863C6.6645 23.4863 8.99838 22.6543 10.8887 21.1107C8.60764 21.0669 6.60114 19.5233 5.90414 17.2682C6.70674 17.4324 7.53046 17.3996 8.31194 17.1697C5.83022 16.6661 4.04549 14.4 4.03493 11.7616C4.03493 11.7397 4.03493 11.7178 4.03493 11.696C4.77417 12.1229 5.60845 12.3637 6.45329 12.3856C4.11942 10.7654 3.39074 7.53594 4.80585 5.00709C7.5199 8.46647 11.5118 10.5574 15.7993 10.7873C15.3664 8.87152 15.9578 6.8572 17.3412 5.49972C19.485 3.40877 22.8643 3.51824 24.892 5.74057C26.0853 5.49972 27.2364 5.03993 28.2819 4.39404C27.8806 5.67488 27.0463 6.75868 25.9374 7.44836C26.9935 7.31699 28.0284 7.02141 29 6.58352C28.2819 7.70015 27.3737 8.66352 26.3282 9.45174Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li class="me-4">
            <a href="#" target="_blank" class="svg-gray">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9948 5.34206C19.4667 5.34206 19.8742 5.35754 21.2464 5.41944C22.5155 5.47619 23.2016 5.6877 23.6607 5.86825C24.2694 6.10555 24.7028 6.38412 25.1567 6.83809C25.6107 7.29206 25.8944 7.72539 26.1266 8.33412C26.302 8.79325 26.5187 9.47936 26.5754 10.7484C26.6373 12.1206 26.6528 12.5282 26.6528 16C26.6528 19.4718 26.6373 19.8794 26.5754 21.2516C26.5187 22.5206 26.3071 23.2067 26.1266 23.6659C25.8893 24.2746 25.6107 24.7079 25.1567 25.1619C24.7028 25.6159 24.2694 25.8996 23.6607 26.1317C23.2016 26.3071 22.5155 26.5238 21.2464 26.5805C19.8742 26.6424 19.4667 26.6579 15.9948 26.6579C12.523 26.6579 12.1155 26.6424 10.7433 26.5805C9.47421 26.5238 8.7881 26.3123 8.32897 26.1317C7.72024 25.8944 7.2869 25.6159 6.83294 25.1619C6.37897 24.7079 6.09524 24.2746 5.8631 23.6659C5.6877 23.2067 5.47103 22.5206 5.41429 21.2516C5.35238 19.8794 5.3369 19.4718 5.3369 16C5.3369 12.5282 5.35238 12.1206 5.41429 10.7484C5.47103 9.47936 5.68254 8.79325 5.8631 8.33412C6.1004 7.72539 6.37897 7.29206 6.83294 6.83809C7.2869 6.38412 7.72024 6.10039 8.32897 5.86825C8.7881 5.69286 9.47421 5.47619 10.7433 5.41944C12.1155 5.35238 12.5282 5.34206 15.9948 5.34206ZM15.9948 3C12.4663 3 12.0226 3.01548 10.6349 3.07738C9.25238 3.13929 8.30833 3.36111 7.48294 3.68095C6.62659 4.01111 5.90437 4.45992 5.18214 5.18214C4.45992 5.90436 4.01627 6.63174 3.68095 7.48293C3.36111 8.30833 3.13929 9.25238 3.07738 10.6401C3.01548 12.0226 3 12.4663 3 15.9948C3 19.5234 3.01548 19.9671 3.07738 21.3547C3.13929 22.7373 3.36111 23.6813 3.68095 24.5119C4.01111 25.3682 4.45992 26.0905 5.18214 26.8127C5.90437 27.5349 6.63175 27.9786 7.48294 28.3139C8.30833 28.6337 9.25238 28.8555 10.6401 28.9174C12.0278 28.9793 12.4663 28.9948 16 28.9948C19.5337 28.9948 19.9722 28.9793 21.3599 28.9174C22.7425 28.8555 23.6865 28.6337 24.5171 28.3139C25.3734 27.9837 26.0956 27.5349 26.8179 26.8127C27.5401 26.0905 27.9837 25.3631 28.319 24.5119C28.6389 23.6865 28.8607 22.7424 28.9226 21.3547C28.9845 19.9671 29 19.5286 29 15.9948C29 12.4611 28.9845 12.0226 28.9226 10.6349C28.8607 9.25238 28.6389 8.30833 28.319 7.47778C27.9889 6.62143 27.5401 5.8992 26.8179 5.17698C26.0956 4.45476 25.3683 4.01111 24.5171 3.67579C23.6917 3.35595 22.7476 3.13413 21.3599 3.07222C19.9671 3.01548 19.5234 3 15.9948 3Z"
                  fill="white"
                />
                <path
                  d="M15.9947 9.32446C12.3114 9.32446 9.31934 12.3114 9.31934 15.9999C9.31934 19.6883 12.3062 22.6752 15.9947 22.6752C19.6832 22.6752 22.6701 19.6883 22.6701 15.9999C22.6701 12.3114 19.6832 9.32446 15.9947 9.32446ZM15.9947 20.328C13.6011 20.328 11.6614 18.3883 11.6614 15.9947C11.6614 13.601 13.6011 11.6614 15.9947 11.6614C18.3884 11.6614 20.3281 13.601 20.3281 15.9947C20.3281 18.3883 18.3884 20.328 15.9947 20.328Z"
                  fill="white"
                />
                <path
                  d="M22.9332 10.6144C23.7936 10.6144 24.4911 9.91689 24.4911 9.05647C24.4911 8.19605 23.7936 7.49854 22.9332 7.49854C22.0728 7.49854 21.3752 8.19605 21.3752 9.05647C21.3752 9.91689 22.0728 10.6144 22.9332 10.6144Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>

      <div>
        <img
          src="../assets/images/logo_getSoothing_01.svg"
          class="h-footerLogo d-block"
          alt="logo-footer"
        />

        <p class="fs-9 mt-3 text-gray-600">© 2022 Get SOOTHING.</p>
      </div>
    </div>
  </div>
</template>
